<template >
  <boxDropDown title="Criar acesso MarQTab">
    <template class="support-tools">

      <div class="form-group col-md-6">
        <label for="nameAccess">Nome</label>
        <input type="text" class="form-control" v-model="dataSend.name" placeholder="Nome" id="nameAccess" name="nameAccess">
      </div>

      <div class="form-group col-md-6">
        <label for="password">Senha</label>
        <input type="password" class="form-control" placeholder="Senha" id="passwordAccess" name="passwordAccessName" v-model="dataSend.password">
      </div>

      <div class="form-group col-md-6">
        <label for="companyId">ID da empresa</label>
        <input type="text" class="form-control" placeholder="ID da empresa" id="companyId" name="companyIdName" v-model="dataSend.companyId">
      </div>

      <div class="form-group col-md-6">
        <label for="email">E-mail</label>
        <input type="text" class="form-control" placeholder="E-mail" id="email" name="emailName" v-model="dataSend.email">
      </div>

      <div class="send-data-tools form-group col-md-12">
        <button class="btn btn-primary" @click="sendData()">
          <span v-if="!loadingMarqTabAccess">Criar</span>
          <span v-else class="loading-btn">
            <div class="spinner-btn">
              <div class="rect1"></div>
              <div class="rect2"></div>
              <div class="rect3"></div>
              <div class="rect4"></div>
              <div class="rect5"></div>
            </div>
          </span>
        </button>
        <span class="send-data-tools__validate">{{ messageValidateFields }}</span>
      </div>
    </template>
  </boxDropDown>
</template>

<script>
  import datepicker from "vuejs-datepicker";
  import boxDropDown from "../../../components/layouts/boxDropDown.vue";
  import {
    REQUEST_SERVICE
  } from "../../../../../requestConfig";
  import {
    ALERT_SERVICE
  } from "../../../../../msgAlertService";
  import {
    CONTEXT_COMPANY,
    CREATE_MARQTAB
  } from "../../../../../urlConfig";

  export default {
    name: "unlock-scale",
    components: {
      boxDropDown,
      datepicker,
    },
    data() {
      return {
        messageValidateFields: "",
        dataSend: {
          name: "",
          password: "",
          companyId: "",
          email: ""
        },
        loadingMarqTabAccess: false,
        contentSetting: ""
      }
    },
    methods: {
      validateFields() {
        if (this.dataSend.name.trim() === "") {
          this.messageValidateFields = "Preencha o campo nome";
          return false;
        }else if (this.dataSend.name.trim().length < 10){
          this.messageValidateFields = "O nome deve conter pelo menos 10 caracteres";
          return;
        }else if (this.dataSend.name.trim().split(" ").length == 1){
          this.messageValidateFields = "O nome deve conter um sobrenome";
          return;
        }
        
        if (this.dataSend.password.trim().length < 6) {
          this.messageValidateFields = "Senha muito curta";
          return false;
        }

        if (this.dataSend.companyId.trim().length !== 32) {
          this.messageValidateFields = "Id da empresa é inválido";
          return false;
        }

        if(!this.isValidEmail(this.dataSend.email.trim())){
          this.messageValidateFields = "Email inváldio";
          return false;
        }

        this.messageValidateFields = "";
        return true;
      },
      sendData() {
        if (!this.validateFields()) {
          return;
        }

        let bodyRequest = {
          companyId: this.dataSend.companyId,
          name: this.dataSend.name.trim(),
          email: this.dataSend.email.trim(),
          password: this.dataSend.password.trim()
        };

        this.loadingMarqTabAccess = true;

        REQUEST_SERVICE.get(`${CONTEXT_COMPANY}${this.dataSend.companyId}`).then((response) => {
          this.contentSetting = response.data;
          let bodyRequestJSON = JSON.stringify(bodyRequest);

          REQUEST_SERVICE.requestContext('POST', CREATE_MARQTAB, this.contentSetting, bodyRequestJSON).then((response) => {
            ALERT_SERVICE.swal("Sucesso", "Acesso MarQTab criado com sucesso!", "success");
            this.clearFields();
            this.loadingMarqTabAccess = false;
          }).catch((reason) => {
            this.loadingMarqTabAccess = false;
            if(reason.response.data.erros.length > 0){
              ALERT_SERVICE.swal("ERRO", reason.response.data.erros[0].value, "error");
            }else{
              ALERT_SERVICE.swal("ERRO", "Entre em contato com a equipe de desenvolvimento", "error");
            }
          });
        }).catch((reason) => {
          this.loadingMarqTabAccess = false;
          ALERT_SERVICE.swal("ERRO", "Entre em contato com a equipe de desenvolvimento", "error");
        });
      },
      clearFields(){
        this.dataSend.name = "";
        this.dataSend.password = "";
        this.dataSend.companyId = "";
        this.dataSend.email = "";
      },
      isValidEmail(value){
        const regexToValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regexToValidEmail.test(value);
      }
    }
  }
</script>

<style lang="scss" scoped>
  * {
    font-family: "Montserrat", sans-serif !important;
  }

  .support-tools {
    &__warning {
      padding: 10px;
      text-align: center;
      background-color: #FFDF8D;
      border-radius: 8px !important;
      color: #FF445D;
    }
  }

  .send-data-tools {
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    gap: 15px;

    &__validate {
      color: #ed6b75;
    }
  }

  .btn-primary {
    margin: 0 !important;
  }

  .full-width{
    width: 100% !important;
  }

  .spacing-bottom{
    margin-bottom: 8px;
  }

  .company-selected {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #F0F0F0;
    padding: 10px 10px 10px 20px;
    margin-bottom: 15px;

    &__title {
      font-weight: bold;
      color: #201E1E;
    }

    &__close {
      height: 16px;
      width: 16px;
      font-size: 16px;
      color: #E74A4E;
      cursor: pointer;
    }
  }

  .center{
    margin: auto;
  }

  .input-with-date {
    width: 100%;

    input {
      width: 100%;
    }
  }

</style>


// WEBPACK FOOTER //
// src/vue/pages/restricted/support/supportItems/marqtabAccess.vue